module.exports = __webpack_public_path__ + "img/King Esport Logo Template.jpg";